module.exports = __webpack_public_path__ + "img/share_close.6f9056ff.png";